//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: ['resident'],
    data: function data() {
        return {
            showListFilter: false,
            residentHistory: [],
            notifications: [],
            violations: [],
            openRequests: [],
            audits: []
        };
    },
    created: function created() {
        Event.$on('get-resident-history', this.getResidentHistory);
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('get-resident-history');
    },

    methods: {
        getResidentHistory: function getResidentHistory() {
            var $el = this;
            $el.resident = $el.resident;
            axios.post("/prototype/person/residents/get-history", { id: $el.resident.id, person_id: $el.resident.person_id }).then(function (response) {
                $el.residentHistory = response.data.history;
                $el.notifications = response.data.notifications;
                $el.violations = response.data.violations;
                $el.audits = response.data.audits;
            });

            axios.get('/prototype/residents/' + $el.resident.id + '/serviceRequests').then(function (response) {
                if (response.data) {
                    var payLoad = [];
                    var payLoadClosed = [];
                    response.data.forEach(function (element) {
                        if (element.completed_at) {
                            payLoadClosed.push(element);
                        } else {
                            payLoad.push(element);
                        }
                    });
                    $el.openRequests = payLoad;
                    $el.closedRequests = payLoadClosed;
                    $el.loading = false;
                }
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/ResidentDetailsHistory.vue
// module id = 8+Yh
// module chunks = 0 1